import React, { useEffect, useState } from "react";
import { Button } from "@hdir/ui/button";
import { Autocomplete } from "@hdir/ui/autocomplete";
import type { Municipality, CompareMunicipalitySelectorProps } from "./types.d";

export function CompareMunicipalitiesList({
  municipalities, labelText, description, buttonText, selectedMunicipality, alignRight
}: CompareMunicipalitySelectorProps): React.JSX.Element {
  const [controlledValue, setControlledValue] = useState<Municipality | undefined>(selectedMunicipality);
  const url = new URL(window.location.href);

  const onCompareMunicipalitySelection = () => {
    if (!controlledValue) return;

    const code = controlledValue.code;
    const url = new URL(window.location.href);
    url.searchParams.set("compareMunicipalityId", code);
    window.history.replaceState({}, "", url.toString());

    // Fire custom event to update PowerBI-component on selection
    window.dispatchEvent(new CustomEvent("compareMunicipalityChange", { detail: code }));
  };

  const handleEnterOrSpace = (e: React.KeyboardEvent<HTMLButtonElement>): void => {
    if (e.key === "Enter" || e.key === " " || e.key === "Spacebar") {
      e.preventDefault();
      e.stopPropagation();
      onCompareMunicipalitySelection();
    }
  };

  useEffect(() => {
    if (!controlledValue) {
      url.searchParams.delete("compareMunicipalityId");
      window.history.replaceState({}, "", url.toString());
      window.dispatchEvent(new CustomEvent("compareMunicipalityChange", { detail: "NULL" }));
    }
  }, [controlledValue]);

  return (
    <section className="flex flex-row">
      <div className={`flex flex-row gap-md ${alignRight && "ml-auto"} py-design-component-mobile tablet:py-design-component-tablet desktop:py-design-component-desktop`}>
        <Autocomplete
          multiselect={false}
          name="KommuneSammenlikning"
          label={labelText}
          items={municipalities}
          defaultValue={selectedMunicipality}
          getItemId={(option) => option.code}
          getDisplayName={(option) => option.name}
          onChange={(value) => setControlledValue(value || undefined)}
          description={description}
        />
        <Button
          role="link"
          aria-label="Velg kommune for sammenlikning"
          onClick={onCompareMunicipalitySelection}
          onKeyDown={handleEnterOrSpace}
          className="self-end"
          variant="secondary"
          disabled={!controlledValue}
        >
          {buttonText}
        </Button>
      </div>
    </section>
  );
}
